// Receivable balance math — mirrors the plan's §3 analytics.
// Per-receivable computed fields (total_owed, total_paid, balance,
// installment_amount, is_settled) are provided by the backend list/get
// responses. Here we only need the portfolio-level aggregate for the list
// header, plus a couple of shared display helpers.

const num = (v) => (typeof v === 'number' && !Number.isNaN(v) ? v : 0);

// Portfolio aggregate across all receivables (§3):
//   total_receivable  = Σ total_owed
//   total_collected   = Σ total_paid
//   total_outstanding = Σ max(balance, 0)
//   active_count      = count where status == Ongoing and not is_settled
export const summarizeReceivables = (items = []) => {
  let totalReceivable = 0;
  let totalCollected = 0;
  let totalOutstanding = 0;
  let activeCount = 0;

  items.forEach((rec) => {
    totalReceivable += num(rec.total_owed);
    totalCollected += num(rec.total_paid);
    totalOutstanding += Math.max(num(rec.balance), 0);
    if (rec.status === 'Ongoing' && !rec.is_settled) activeCount += 1;
  });

  return {
    totalReceivable,
    totalCollected,
    totalOutstanding,
    activeCount,
  };
};

// Colour for a balance figure: green when settled / nothing outstanding,
// red while there is still money owed.
export const balanceColor = (balance, isSettled) => {
  if (isSettled || num(balance) <= 0) return '#4CAF50';
  return '#f44336';
};

// Colour for a status badge.
export const statusColor = (status) => {
  switch (status) {
    case 'Settled':
      return '#4CAF50';
    case 'Written-off':
      return '#9E9E9E';
    case 'Ongoing':
    default:
      return '#4a9eff';
  }
};

// Display helper for money amounts (no currency util exists in this app).
export const formatMoney = (v) => {
  if (v == null || v === '') return '—';
  const n = typeof v === 'number' ? v : parseFloat(v);
  if (Number.isNaN(n)) return '—';
  return n.toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export default summarizeReceivables;
